import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect } from 'react-router-dom';

import {
  DataHandler,
  APIHandler,
  Image,
} from 'C4';
import { storageKeys } from 'settings';

const crumbRoutes = {
  '/main': 'Home',
  '/main/sell': 'Sell',
  '/main/sell/images': 'Image Library',
};

export default class CarouselImages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlideIndex: 0,
      images: [],
      escaped: false,
    };

    this.handleAfterSlide = this.handleAfterSlide.bind(this);
    this.onEsc = this.onEsc.bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onEsc);
    DataHandler.matchAppId().then((id) => {
      const appId = id;
      DataHandler.checkKey(storageKeys.images, APIHandler.getImages(appId))
        .then((res) => {
          this.setState({ images: res.items });
        });
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  handleAfterSlide(newSlideIndex) {
    this.setState({ currentSlideIndex: newSlideIndex });
  }

  render() {
    const { images, currentSlideIndex, escaped } = this.state;
    const imageItems = [];
    images.forEach((imageItem, id) => {
      const {
        image,
        title,
      } = imageItem;
      const key = id;

      // if (key <= (currentSlideIndex + 1) && key >= (currentSlideIndex - 1)) {
      if (key <= (currentSlideIndex + 1)) {
        imageItems.push((
          <div key={key} >
            <h3>{title}</h3>
            {/* <img src={image} alt={title} /> */}
            <Image
              src={image}
              alt={title}
              // size={{ width: '10rem', height: '10rem' }}
            />
          </div>));
      } else {
        imageItems.push(<div key={key} />);
      }
      return null;
    });

    const { url, params } = this.props.match;
    const { videoId } = params;

    const redirPath = (
      videoId !== undefined
        ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/')
        : url.lastIndexOf('/')
    );

    return (
      <div className="carouselImages__Container">
        <div className="carouselImages__Background--overlay" />
        <Breadcrumbs
          mappedRoutes={crumbRoutes}
          WrapperComponent={props => <ul className="breadcrumb__List">{props.children}</ul>}
          LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
          ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
        />
        {/* <Carousel
          slideIndex={this.state.currentSlideIndex}
          afterSlide={this.handleAfterSlide}
          easing="easeExpOut"
          edgeEasing="easeExpInOut"
          framePadding="0px"
          cellSpacing={100}
          cellAlign="center"
          width="96rem"
          height="72rem"
          slideWidth="1024px"
          slideHeight="768px"
          heightMode="first"
          initialSlideWidth={1024}
          initialSlideHeight={768}
          frameOverflow="visible"
          renderCenterLeftControls={({ previousSlide }) => (
            <button onClick={previousSlide} >
              <FontAwesomeIcon icon={['fas', 'angle-left']} />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button onClick={nextSlide}>
              <FontAwesomeIcon icon={['fas', 'angle-right']} />
            </button>
          )}
        >
          {imageItems}
        </Carousel> */}
        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CarouselImages.propTypes = {
  match: PropTypes.shape().isRequired,
};
